import React, { useEffect, useState } from "react";
import { Button, Card, Col, Image, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getChapterDetail } from "../../api/bookService";
import characterimg from '../../assets/img/characterimg1.jpg';

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function Chapterdetails() {
  const { chapterId } = useParams();
  const [chapter, setChapter] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchChapterDetails = async () => {
    try {
      const response = await getChapterDetail({ chapterId });
      console.log("=== chapter detail response ===", response);
      if (response.status) {
        setChapter(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch chapter details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChapterDetails();
  }, [chapterId]);

  if (loading) {
    return <p className="text-center mt-5">Loading chapter details...</p>;
  }

  if (!chapter) {
    return <p className="text-center mt-5">No chapter details found.</p>;
  }

  return (
    <React.Fragment>
      <Card>
        <Card.Header className="d-flex align-items-center justify-content-between">
          <h5>Chapter Details</h5>
          <Button className="btn btn-primary-light px-4 min_width140" as={Link} to={`/books/view-book/${chapter.bookId}`}>
            Back
          </Button>
        </Card.Header>
        <Card.Body className="taledtl_div mt-3">
          <Row className="g-3 mb-4">
            <Col md="4">
              <div className="talefile_box">
                <Image
                  className="talefile_img"
                  src={chapter.coverImage ? `${MEDIA_URL}/${chapter.coverImage}` : characterimg}
                  alt="Chapter"
                />
              </div>
            </Col>
            <Col md="8">
              <div className="talefile_list">
                <div className="tablefilelist_grid">
                  <h4>Title</h4>
                  <p>{chapter.title || "N/A"}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Chapter</h4>
                  <p>{chapter.chapterNumber || "N/A"}</p>
                </div>
                <div className="tablefilelist_grid">
                  <h4>Description</h4>
                  <p>{chapter.description || "N/A"}</p>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </React.Fragment>
  );
}
